var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getOrSetDefaultValue } from './utils';
var DynamicWorkflowDefinitionManager = /** @class */ (function () {
    function DynamicWorkflowDefinitionManager() {
        this.workflowDefByWorkflowAndContextId = new Map();
        this.workflowDefByWorkflow = new Map();
    }
    DynamicWorkflowDefinitionManager.mergeDefinitions = function (defaultDefinition, currentOverride, newOverride) {
        return __assign(__assign(__assign({}, defaultDefinition), currentOverride), newOverride);
    };
    DynamicWorkflowDefinitionManager.prototype.mergeWorkflowDefinition = function (workflow, workflowDefinition, contextId) {
        if (contextId) {
            var currentDefs = getOrSetDefaultValue(this.workflowDefByWorkflowAndContextId, workflow.id, function () { return new Map(); });
            currentDefs.set(contextId, DynamicWorkflowDefinitionManager.mergeDefinitions(workflow, currentDefs.get(contextId), workflowDefinition));
        }
        else {
            this.workflowDefByWorkflow.set(workflow.id, DynamicWorkflowDefinitionManager.mergeDefinitions(workflow, this.workflowDefByWorkflow.get(workflow.id), workflowDefinition));
        }
    };
    DynamicWorkflowDefinitionManager.prototype.getWorkflowDefinition = function (workflow, contextId) {
        var _a;
        var definition;
        if (contextId) {
            definition = (_a = this.workflowDefByWorkflowAndContextId.get(workflow.id)) === null || _a === void 0 ? void 0 : _a.get(contextId);
        }
        if (!definition) {
            definition = this.workflowDefByWorkflow.get(workflow.id);
        }
        if (!definition) {
            definition = workflow;
        }
        return definition;
    };
    DynamicWorkflowDefinitionManager.prototype.deleteWorkflowDefinition = function (workflow, contextId) {
        var definitionByContextId = this.workflowDefByWorkflowAndContextId.get(workflow.id);
        if (definitionByContextId) {
            definitionByContextId.delete(contextId);
            if (definitionByContextId.size === 0) {
                this.workflowDefByWorkflowAndContextId.delete(workflow.id);
            }
        }
    };
    return DynamicWorkflowDefinitionManager;
}());
export { DynamicWorkflowDefinitionManager };
//# sourceMappingURL=dynamic-workflow-definition-manager.js.map